var map = {
	"./Afshari - (260 x 205 cm).jpg": 5469,
	"./Afshari - (290 x 200 cm) (1).jpg": 4723,
	"./Afshari - (290 x 200 cm) (2).jpg": 2238,
	"./Bijar - (215 x 170 cm).jpg": 3482,
	"./Kilim Turco tülü - Doppia lati - Lana sulla lana (280 x 150 cm).jpg": 7616,
	"./La Farfalla - Seta e kork (200 x 150 cm).jpg": 5159,
	"./Tappeto Afshari - Botte - (325 x 185 cm).jpg": 5428,
	"./Tappeto afshari (290 x 200 cm).jpg": 8409,
	"./Tappeto afshari - (240 x 180 cm).jpg": 9602,
	"./Tappeto cinese DECO (270 x 190 cm).jpg": 4963,
	"./Tappeto moderno (285 x 200 cm).jpg": 8785,
	"./Tappeto moderno - Afshari - (2 x 140 cm).jpg": 8073,
	"./Tappeto moderno - Afshari - (285 x 200 cm).jpg": 3479,
	"./Tappeto moderno - Sirjan afshari - (285 x 190 cm).jpg": 2870,
	"./Tappeto moderno - Tappeto afshari - Gol farang - Firmato (290 x 205 cm).jpg": 9177,
	"./Tappeto sirjan - (290 x 175 cm).jpg": 5272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8092;